import {
  ItemWrapper,
  ContentWrapper,
  Error,
  InputWrapper,
  ButtonsWrapper,
  NotificationWrapper,
} from "../../styles";
import { useAppDispatch, useAppSelector } from "../../../../../../app/hooks";

import { CNYProps, FormInputs } from "../../../../../../types/walletTypes";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { savedCNYData } from "../../../../redux/formDataSlice";
import { Button } from "../../../../../../components/common/Button";

import { InputPhone } from "../../../../../../components/common/InputPhone";
import { Input } from "../../../../../../components/common/Input";
import CustomSelect from "../../../../../../components/common/CustomSelect";
import { WECHAT_RELATIONSHIPS } from "../../../../const";
import React from "react";
import { ReactComponent as InfoIcon } from "../../../../../../assets/icons/info.svg";

const WeChatBeneficiaryForm = ({ handleNext, handlePrevious }: CNYProps) => {
  const getSavedData = useAppSelector((state) => state.formData.cnyData);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormInputs>({ defaultValues: getSavedData || {} });

  const dispatch = useAppDispatch();

  const onSubmit: SubmitHandler<FormInputs> = (data) => {
    dispatch(savedCNYData(data));
    handleNext?.();
  };

  return (
    <ContentWrapper>
      <ItemWrapper>
        <InputWrapper>
          <Controller
            name="receiverFirstName"
            control={control}
            rules={{ required: "First name is required" }}
            render={({ field }) => (
              <Input
                type="text"
                label="First name"
                value={field.value}
                onChange={field.onChange}
                hasError={!!errors.receiverFirstName}
                labelColor="#FFFFFF"
              />
            )}
          />
          <NotificationWrapper>
            <InfoIcon />
            <p>The name must be in Chinese.</p>
          </NotificationWrapper>
          <Error>{errors?.receiverFirstName?.message}</Error>
        </InputWrapper>

        <InputWrapper>
          <Controller
            name="receiverLastName"
            control={control}
            rules={{ required: "Last name is required" }}
            render={({ field }) => (
              <Input
                type="text"
                label="Last name"
                value={field.value}
                onChange={field.onChange}
                hasError={!!errors.receiverLastName}
                labelColor="#FFFFFF"
              />
            )}
          />
          <NotificationWrapper>
            <InfoIcon />
            <p>The name must be in Chinese.</p>
          </NotificationWrapper>
          <Error>{errors?.receiverLastName?.message}</Error>
        </InputWrapper>
      </ItemWrapper>

      <InputWrapper>
        <Controller
          name="receiverMobileNumber"
          control={control}
          rules={{ required: "WeChat ID or phone number is required" }}
          render={({ field }) => (
            <InputPhone
              label="WeChat ID or Phone number"
              field={field}
              defaultCountry="CN"
            />
          )}
        />
        <Error>{errors?.receiverMobileNumber?.message}</Error>
      </InputWrapper>

      <InputWrapper>
        <Controller
          name="receiverRelationship"
          control={control}
          rules={{ required: "Field is required" }}
          render={({ field }) => (
            <CustomSelect
              options={WECHAT_RELATIONSHIPS}
              $width="100%"
              placeholder="Relationship"
              value={field.value}
              onChange={field.onChange}
              lightBorder
            />
          )}
        />
        <Error>{errors?.receiverRelationship?.message}</Error>
      </InputWrapper>

      <ButtonsWrapper>
        <Button
          onClick={handlePrevious}
          label="Back"
          height="48px"
          theme="alternate"
          width="203px"
        />
        <Button
          onClick={handleSubmit(onSubmit)}
          label="Continue"
          height="48px"
        />
      </ButtonsWrapper>
    </ContentWrapper>
  );
};

export default WeChatBeneficiaryForm;
